module.exports = __webpack_public_path__ + "static/img/ivoice_blue_bg.79daed8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/new_home/ivoice_blue_bg.png
// module id = 504
// module chunks = 0